<footer class="footer d-flex flex-column flex-md-row align-items-center justify-content-between px-4 py-3 border-top small">
  <p class="text-secondary mb-1 mb-md-0">Copyright © 2024 <a href="https://amjamassociates.com/" target="_blank">AMJAM & Associates</a>.</p>
  <p>All Values in <b>Sierra Leonean Leone </b><span class="badge rounded-pill bg-primary">SLL</span>
</footer>
